export enum LoginEvent {
    Login = 0,
    Logout = 1, 
    LoginFailed = 2
  }